import { Image } from '@/components/client';

import { TYPOGRAPHY_IMAGES } from '../../constants';

export const WelloPointCard = () => {
  return (
    <div className="relative flex w-full flex-col items-center gap-10 text-center">
      <p className="absolute -top-2 left-1/2 w-full -translate-x-1/2 whitespace-pre-line font-600 !leading-[1.1] text-Gray-600 typo-caption1">
        {'10만원 이상\n기부시'}
      </p>
      <div className="invisible w-full whitespace-pre-line font-600 !leading-[1.1] typo-caption1">
        {'10만원 이상\n기부시'}
      </div>
      <Image
        src={TYPOGRAPHY_IMAGES.welPoint2000.url}
        alt={TYPOGRAPHY_IMAGES.welPoint2000.alt}
        width={TYPOGRAPHY_IMAGES.welPoint2000.width}
        height={TYPOGRAPHY_IMAGES.welPoint2000.height}
        loading="lazy"
        className="object-contain"
      />
    </div>
  );
};

export const PhotoReviewCard = () => {
  return (
    <div className="relative flex w-full flex-col items-center gap-10 text-center">
      <p className="absolute -top-2 left-1/2 w-full -translate-x-1/2 whitespace-pre-line font-600 !leading-[1.1] text-Gray-600 typo-caption1">
        {'포토리뷰\n작성시'}
      </p>
      <div className="invisible w-full whitespace-pre-line font-600 !leading-[1.1] typo-caption1">
        {'포토리뷰\n작성시'}
      </div>
      <Image
        src={TYPOGRAPHY_IMAGES.welPoint1000.url}
        alt={TYPOGRAPHY_IMAGES.welPoint1000.alt}
        width={TYPOGRAPHY_IMAGES.welPoint1000.width}
        height={TYPOGRAPHY_IMAGES.welPoint1000.height}
        loading="lazy"
        className="object-contain"
      />
    </div>
  );
};

export const FriendInviteCard = () => {
  return (
    <>
      <div className="absolute -top-20 left-1/2 h-37 w-63 -translate-x-1/2">
        <div className="relative flex size-full items-center justify-center">
          <svg
            className="absolute inset-0 size-full object-contain"
            width="63"
            height="36"
            viewBox="0 0 63 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M49 0C56.732 0 63 6.27 63 14C63 21.732 56.732 28 49 28H37.92L33.13 34.72C32.33 35.83 30.67 35.83 29.87 34.72L25.08 28H14C6.27 28 0 21.732 0 14C0 6.27 6.27 5.64e-08 14 0H49Z"
              fill="url(#paint0_linear_22948_4871)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_22948_4871"
                x1="0"
                y1="18.5"
                x2="63"
                y2="18.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF8428" />
                <stop offset="1" stopColor="#FF4800" />
              </linearGradient>
            </defs>
          </svg>

          <Image
            src={TYPOGRAPHY_IMAGES.unlimited.url}
            alt={TYPOGRAPHY_IMAGES.unlimited.alt}
            width={TYPOGRAPHY_IMAGES.unlimited.width}
            height={TYPOGRAPHY_IMAGES.unlimited.height}
            loading="lazy"
            className="relative z-10 object-contain pb-6"
          />
        </div>
      </div>
      <div className="flex w-full flex-col items-center gap-10 text-center">
        <p className="absolute left-1/2 top-40 w-full -translate-x-1/2 whitespace-pre-line font-600 !leading-[1.1] text-Gray-600 typo-caption1">
          친구 초대 시
        </p>
        <p className="invisible w-full whitespace-pre-line font-600 !leading-[1.1] typo-caption1">
          {'친구 \n초대 시'}
        </p>
        <Image
          src={TYPOGRAPHY_IMAGES.welPoint2000.url}
          alt={TYPOGRAPHY_IMAGES.welPoint2000.alt}
          width={TYPOGRAPHY_IMAGES.welPoint2000.width}
          height={TYPOGRAPHY_IMAGES.welPoint2000.height}
          loading="lazy"
          className="object-contain"
        />
      </div>
    </>
  );
};
